<template>
  <aside :class="['main-sidebar', $store.getters.env]">
    <section class="sidebar">
      <div class="user-panel">
        <div class="pull-left image">
          <img :src="`/static/img/${user.image}`" class="img-circle" alt="User Image">
        </div>
        <div class="pull-left info">
          <div><p>{{user.company}}</p></div>
          <a href="javascript:;"><i class="fa fa-circle text-success glow"></i> {{user.first_name}} {{user.last_name}}</a>
        </div>
      </div>
      <form @submit.prevent="$router.push(`/orders/${goto}`)" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="search" id="gotoOrder" class="search form-control" data-toggle="hideseek" :placeholder="'goto_order' | translate"  v-model="goto">
          <span class="input-group-btn">
                <button type="submit" name="search" id="gotoOrder-btn" class="btn btn-flat"><i class="fa fa-search"></i>
                </button>
              </span>
        </div>
      </form>
      <form @submit.prevent="goToMp()" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="search" id="gotoMPOrder" class="search form-control" data-toggle="hideseek" :disabled="processing.mp" placeholder="MP ID"  v-model="gotoMP">
          <span class="input-group-btn">
            <button type="submit" name="search" id="gotoMPOrder-btn" class="btn btn-flat" :disabled="processing.mp" ><i :class="[processing.mp ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
            </button>
          </span>
        </div>
      </form>
      <form @submit.prevent="goToMpAddition()" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="search" id="gotoOrderNumberAddition" class="search form-control" data-toggle="hideseek" :placeholder="'order_number_addition' | translate"  v-model="gotoMPAdditionModel">
          <span class="input-group-btn">
            <button type="submit" name="search" id="gotoOrderNumberAddition-btn" class="btn btn-flat" :disabled="processing.mp" ><i :class="[processing.mp ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
                </button>
              </span>
        </div>
      </form>
      <form @submit.prevent="findOrder('line', gotoLine)" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="search" id="gotoLine" class="search form-control" :disabled="processing.line" data-toggle="hideseek" placeholder="Line ID"  v-model="gotoLine">
          <span class="input-group-btn">
            <button type="submit" name="search" id="gotoLine-btn" class="btn btn-flat" :disabled="processing.line" ><i :class="[processing.line ? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
            </button>
          </span>
        </div>
      </form>
      <ul class="sidebar-menu sidebar">
        <li
          :class="{ active: $route.path === '/home', pageLink: true }"
          @click="toggleMenu"
        >
          <router-link to="/home">
            <i class="fa fa-dashboard"></i>
            <span class="page">{{'dashboard' | translate }}</span>
          </router-link>
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'co_orders')"
          :class="{ active: $route.path === '/orders', pageLink: true }"
          @click="toggleMenu"
        >
          <router-link to="/orders">
            <i class="fa fa-shopping-cart"></i>
            <span class="page">{{'orders' | translate }}</span>
          </router-link>
        </li>
<!--        <li-->
<!--          v-if="$store.dispatch('checkPermissions', 'co_orders')"-->
<!--          :class="{ active: $route.path === '/click-and-collect', pageLink: true }"-->
<!--          @click="toggleMenu"-->
<!--        >-->
<!--          <router-link to="/click-and-collect">-->
<!--            <i class="fa fa-shopping-bag"></i>-->
<!--            <span class="page">{{ 'click-and-collect' | translate }}</span>-->
<!--            <span class="pull-right-container">-->
<!--                <small class="label pull-right bg-success">{{ccCount}}</small>-->
<!--              </span>-->
<!--          </router-link>-->
<!--        </li>-->
        <li
          v-if="$store.dispatch('checkPermissions', 'co_accounting')"
          :class="{ active: $route.path.substr(0, 18) === '/productmanagement', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-desktop"></i>
            <span>{{'productmanagement' | translate }}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              v-if="$store.dispatch('checkPermissions', 'service')"
              :class="{ active: $route.path.substr(0, 27) === '/productmanagement/products', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/productmanagement/products" id="productStats">
                <i class="fa fa-tags"></i>
                <span class="page leaf">{{'products' | translate}}</span>
              </router-link>
            </li>
            <li
              v-if="$store.dispatch('checkPermissions', 'service')"
              :class="{ active: $route.path === '/productmanagement/top-seller', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/productmanagement/top-seller" id="topSeller">
                <i class="fa fa-money"></i>
                <span class="page leaf">{{'top-seller' | translate}}</span>
              </router-link>
            </li>
            <li
              v-if="$store.dispatch('checkPermissions', 'service')"
              :class="{ active: $route.path === '/productmanagement/storewindow', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/productmanagement/storewindow" id="storeWindow">
                <i class="fa fa-diamond"></i>
                <span class="page leaf">{{'storewindow' | translate}}</span>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="header">
          {{'administration' | translate}}
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'co_accounting')"
          :class="{ active: $route.path.substr(0, 11) === '/directsale', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-angle-double-right"></i>
            <span>{{'directsale' | translate  }}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              :class="{ active: $route.path === '/directsale/general-settings', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/directsale/general-settings">
                <span class="page leaf">{{ 'general-settings' | translate }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/directsale/gaxsys', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/directsale/gaxsys">
                <span class="page leaf">Gaxsys</span>
              </router-link>
            </li>
            <li
              v-if="user.erp_system_name === 'etos' || user.erp_system_name === 'etosApollon' || user.erp_system_name === 'ipos' || user.erp_system_name === 'his' || user.erp_system_name === 'bits'"
              :class="{ active: $route.path === '/directsale/amazon', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/directsale/amazon">
                <span class="page leaf">{{'amazon' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/directsale/avendu', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/directsale/avendu">
                <span class="page leaf">{{'avendu' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/directsale/atalanda', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/directsale/atalanda">
                <span class="page leaf">{{'atalanda' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/directsale/bagmondo', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/directsale/bagmondo">
                <span class="page leaf">{{'bagmondo' | translate}}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'co_accounting')"
          :class="{ active: $route.path.substr(0, 11) === '/management', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-desktop"></i>
            <span>{{'management' | translate  }}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              :class="{ active: $route.path === '/management/users', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/management/users">
                <i class="fa fa-user-circle-o"></i>
                <span class="page leaf">{{'users' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path.substr(0, 18) === '/management/stores', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/management/stores">
                <i class="fa fa-home"></i>
                <span class="page leaf">{{'stores' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/management/company', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/management/company">
                <i class="fa fa-building-o"></i>
                <span class="page leaf">{{'company' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/management/status', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/management/status">
                <i class="fa fa-building-o"></i>
                <span class="page leaf">{{'stores_status' | translate  }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'co_accounting')"
          :class="{ active: $route.path.substr(0, 10) === '/downloads', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-download"></i>
            <span>{{'downloads' | translate  }}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              :class="{ active: $route.path === '/downloads/orders', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/downloads/orders">
              <i class="fa fa-file-pdf-o"></i>
                <span class="page leaf">{{'orders' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/downloads/files', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/downloads/files">
                <i class="fa fa-files-o"></i>
                <span class="page leaf">{{'files' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/downloads/click-and-collect', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/downloads/click-and-collect">
                <i class="fa fa-tags"></i>
                <span class="page leaf">{{'click-and-collect' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/downloads/shipcloud-receipts', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/downloads/shipcloud-receipts">
                <i class="fa fa-cloud"></i>
                <span class="page leaf">{{'shipcloud-receipts' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/downloads/monthly-reports', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/downloads/monthly-reports">
                <i class="fa fa-cloud-download"></i>
                <span class="page leaf">{{'monthly-reports' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/downloads/tracking-codes', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/downloads/tracking-codes">
                <i class="fa fa-cloud-download"></i>
                <span class="page leaf">{{'tracking-codes' | translate  }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'co_products')"
          :class="{ active: $route.path.substr(0, 6) === '/bills', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-cloud-download"></i>
            <span>{{'bills' | translate  }}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              :class="{ active: $route.path === '/bills/bills', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/bills/bills">
                <i class="fa fa-cloud-download"></i>
                <span class="page leaf">{{'bills' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/bills/service-bills', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/bills/service-bills">
                <i class="fa fa-cloud-download"></i>
                <span class="page leaf">{{'service-bills' | translate  }}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/bills/archived-bills', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/bills/archived-bills">
                <i class="fa fa-cloud-download"></i>
                <span class="page leaf">{{'archived-bills' | translate  }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'co_accounting')"
          :class="{ active: $route.path.substr(0, 9) === '/settings', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-cogs"></i>
            <span>{{'settings' | translate  }}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              :class="{ active: $route.path === '/settings/pricing-rules', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/settings/pricing-rules">
                <i class="fa fa-money"></i>
                <span class="page leaf">{{'pricing-rules' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/settings/tamaris-pricing-rules', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/settings/tamaris-pricing-rules">
                <i class="fa fa-money"></i>
                <span class="page leaf">{{'tamaris-pricing-rules' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/settings/shipping', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/settings/shipping">
                <i class="fa fa-money"></i>
                <span class="page leaf">{{'shipping' | translate}}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          v-if="$store.dispatch('checkPermissions', 'service')"
          :class="{ active: $route.path.substr(0, 9) === '/overview', treeview: true }"
        >
          <a class="collapsable" href="#">
            <i class="fa fa-eye"></i>
            <span>{{'overview' | translate}}</span>
            <span class="pull-right-container">
              <span class="sub-indicate"></span>
            </span>
          </a>
          <ul class="treeview-menu">
            <li
              :class="{ active: $route.path === '/overview/orders', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/overview/orders" id="overviewOrders">
                <i class="fa fa-tags text-info"></i>
                <span class="page leaf">{{'open-orders' | translate | capitalize}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/overview/unknown-status', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/overview/unknown-status" id="overviewUnknown">
                <i class="fa fa-warning text-danger"></i>
                <span class="page leaf">{{'unknown-status' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/overview/returns', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/overview/returns" id="overviewReturns">
                <i class="fa fa-retweet text-warning"></i>
                <span class="page leaf">{{'returns' | translate}}</span>
              </router-link>
            </li>
            <li
              :class="{ active: $route.path === '/overview/labels', pageLink: true, leaf: true, hidden: false }"
              @click="toggleMenu"
            >
              <router-link to="/overview/labels" id="labels">
                <i class="fa fa-warning text-danger"></i>
                <span class="page leaf">{{'label_errors' | translate}}</span>
                <span class="pull-right-container">
                  <small class="label pull-right bg-danger">
                    <span v-if="labelErrorCount">{{labelErrorCount}}</span>
                    <i class="fa fa-spinner fa-spin" v-else></i>
                  </small>
                </span>
              </router-link>
            </li>
          </ul>
        </li>
        <li
          :class="{ active: $route.path === '/create-label', pageLink: true }"
          @click="toggleMenu"
        >
          <router-link to="/create-label">
            <i class="fa fa-clone"></i>
            <span class="page">{{'create-label' | translate}}</span>
          </router-link>
        </li>
        <li class="header">
          INFO
        </li>
        <li
          :class="{ active: $route.path === '/faq', pageLink: true }"
          @click="toggleMenu"
        >
          <router-link to="/faq">
            <i class="fa fa-info"></i>
            <span class="page">{{'faq' | translate}}</span>
          </router-link>
        </li>
        <li
          :class="{ active: $route.path === '/materials-order', pageLink: true }"
          @click="toggleMenu"
        >
          <router-link to="/materials-order">
            <i class="fa fa-cube"></i>
            <span class="page">{{'materials-order' | translate}}</span>
          </router-link>
        </li>
        <li
          :class="{ active: $route.path === '/notifications', pageLink: true }"
          @click="toggleMenu"
        >
          <router-link to="/notifications">
            <i class="fa fa-newspaper-o mr-5"></i>
            <span class="page">{{'notifications' | translate}}</span>
          </router-link>
        </li>
      </ul>
    </section>
  </aside>
</template>

<script>
export default {
  name: 'SideBar',
  data () {
    return {
      user: this.$store.getters.user,
      processing: {
        line: false,
        mp: false
      },
      goto: '',
      gotoLine: '',
      gotoMPAdditionModel: '',
      gotoMP: '',
      ccCount: 0,
      labelErrorCount: false
    }
  },
  mounted () {
    API.get('/observation/labels/failed')
      .then(res => {
        this.labelErrorCount = res.data.length
      })
  },
  methods: {
    toggleMenu (event) {
      if (
        !event.target.classList.contains('leaf') &&
        !event.target.parentElement.classList.contains('leaf')
      ) {
        $('li.treeview').removeClass('active')
        if ($('ul.treeview-menu.menu-open').length > 0) {
          $('ul.treeview-menu.menu-open')[0].previousElementSibling.click()
        }
      }
      event.target.parentElement.className = 'pageLink active'
    },
    findOrder (type, id) {
      this.processing.line = true
      if (id === '') {
        this.$router.push('/orders')
      } else {
        API.get(`/orders/find/${type}/${id}`)
          .then(res => {
            this.$router.push(`/orders/${res.data.order_id}`)
            this.processing.line = false
          })
          .catch(error => {
            let alert = {type: 'danger', dismiss: 4, message: `Order not found for ${type}-ID ${id}`, icon: 'icon fa fa-ban'}
            this.$store.commit('pushAlert', alert)
            this.processing.line = false
          })
      }
    },
    goToMp () {
      this.processing.mp = true
      if (this.gotoMP === '') {
        this.processing.mp = false
        this.$router.push('/orders')
      } else {
        API.get(`orders?ext_order_id=${this.gotoMP}`)
          .then(response => {
            this.processing.mp = false
            if (response.data.data.length > 1 || response.data.data.length === 0) {
              this.$router.push('/orders/error')
            } else {
              this.$router.push(`/orders/${response.data.data[0].id}`)
            }
          })
      }
    },
    goToMpAddition () {
      this.processing.mp = true
      if (this.goToMpAdditionModel === '') {
        this.processing.mp = false
        this.$router.push('/orders')
      } else {
        API.get(`orders?ext_order_id_addition=${this.gotoMPAdditionModel}`)
          .then(response => {
            this.processing.mp = false
            if (response.data.data.length > 1 || response.data.data.length === 0) {
              this.$router.push('/orders/error')
            } else {
              this.$router.push(`/orders/${response.data.data[0].id}`)
            }
          })
      }
    },
    checkEnv () {
      return ['qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de'].indexOf(window.location.hostname) !== -1
    }
  }
}
</script>

<style scoped>
  .staging {
    background-color: #5b4094 !important;
  }
  .dev {
    background-color: #136178 !important;
  }
  .logo-st{
    width: 70%;
    -webkit-animation:spin 4s linear infinite;
    -moz-animation:spin 4s linear infinite;
    animation:spin 4s linear infinite;
    height: 50px !important;
  }
  @-moz-keyframes spin { 100% { -moz-transform: rotateY(360deg); } }
  @-webkit-keyframes spin { 100% { -webkit-transform: rotateY(360deg); } }
  @keyframes spin { 100% { -webkit-transform: rotateY(360deg); transform:rotateY(360deg); } }
</style>



// WEBPACK FOOTER //
// src/components/tools/SideBar.vue